module.exports = __webpack_public_path__ + "static/media/core_1.2388129c.png";